// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","105":"36b345740a00d1bb38f8","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"baf3586c3ff625cef128","765":"85e2cb3a12e4732aa483","852":"78cb0656d5df0607e4e4"}[chunkId] + ".bundle.js";
};